export const CONSTANTS = {
  "SPLASH": {
    "text": "made with",
    "backgroundColor": "#1A1A1A",
    "textColor": "#E5E5E5",
    "imageCategory": "logos",
    "imageKey": "splash",
    "imageDisplayWidth": 192,
    "imageDisplayHeight": 192,
    "imageBackgroundColor": "#FFFFFF",
    "popScaleFrom": 0.8,
    "popOvershoot": 1.08,
    "popScaleTo": 1,
    "popDurationMs": 700,
    "gridColor": "#404040",
    "gridDotSize": 1,
    "gridSpacing": 20,
    "fadeOutDelayMs": 2000,
    "fadeOutDurationMs": 800,
    "fadeOutScaleTo": 0.8
  },
  "board": {
    "baseIconSize": 64,
    "height": 900,
    "width": 1600
  },
  "collections": [
    {
      "key": "first_tools",
      "name": "The First Tools",
      "description": "Mastering the fundamental elements that lifted humanity out of the primordial ooze.",
      "elements": ["stone", "fire", "tool", "wood", "wheel", "shelter"],
      "reward": {
        "avatarKey": "flintknapper",
        "lore": "With mastery over stone and fire, humanity first shaped its destiny, creating tools that would build empires and spark innovation for millennia to come."
      }
    },
    {
      "key": "ancient_wonders",
      "name": "Wonders of Antiquity",
      "description": "Constructing the monumental works that defined the great classical and medieval empires.",
      "elements": ["temple", "castle", "bridge", "ship", "road", "writing"],
      "reward": {
        "avatarKey": "architect",
        "lore": "From soaring temples to continent-spanning roads, these marvels of engineering connected peoples, enabled trade, and stood as testaments to the ambition of early civilizations."
      }
    },
    {
      "key": "digital_revolution",
      "name": "The Digital Revolution",
      "description": "Harnessing the power of silicon and electricity to connect the world in a global network.",
      "elements": ["computer", "internet", "chip", "smartphone", "network", "silicon"],
      "reward": {
        "avatarKey": "hacker",
        "lore": "The digital age transformed the very fabric of reality, shrinking the globe into a village and unlocking computational power that rivals the gods of old."
      }
    },
    {
      "key": "art_and_culture",
      "name": "Art & Culture",
      "description": "Expressing the human spirit through creativity and tradition.",
      "elements": ["music", "art", "sculpture", "story", "myth", "festival"],
      "reward": {
        "avatarKey": "bard",
        "lore": "From the first drumbeat to epic myths, culture is the thread that weaves society together, giving meaning and beauty to existence."
      }
    },
    {
      "key": "industrial_revolution",
      "name": "The Industrial Revolution",
      "description": "Unleashing the power of steam and steel to reshape the world with mechanical might.",
      "elements": ["steam", "engine", "factory", "train", "electricity", "wire"],
      "reward": {
        "avatarKey": "inventor",
        "lore": "The roar of the engine and the hum of the factory became the new pulse of civilization, forging an era of unprecedented production and progress."
      }
    },
    {
      "key": "cosmic_pioneers",
      "name": "Cosmic Pioneers",
      "description": "Breaking the bonds of Earth to explore the final frontier and settle among the stars.",
      "elements": ["rocket", "space", "star", "space_station", "mars_colony", "terraformer"],
      "reward": {
        "avatarKey": "astronaut",
        "lore": "With courage and ingenuity, humanity stepped off its home world, becoming a multi-planetary species and beginning its true cosmic journey."
      }
    }
  ],
  "bosses": {
    "stone_age": {
      "name": "Grok the Flintkeeper",
      "description": "A massive caveman wielding primitive stone tools, guardian of the ancient ways.",
      "initialDialogue": [
        "Grok see small tribe try to leave stone ways...",
        "Stone strong! Stone eternal! Grok protect old ways!",
        "You must prove worthy to move beyond stone and fire!"
      ],
      "defeatDialogue": [
        "Grok... impressed. Small tribe show great wisdom.",
        "Stone ways good, but new ways... also have strength.",
        "Grok give blessing. Go forth, make new tools, new life!"
      ],
      "playerDefeatDialogue": [
        "Small tribe not ready. Your ideas weak like twig.",
        "Grok's ways are strong. Go back, learn more from stone and fire.",
        "Come back when you have true strength!"
      ],
      "deck": ["stone", "fire", "tool", "hunting", "animal", "shelter", "tribe", "cooking", "water", "earth", "sound", "light"]
    },
    "bronze_age": {
      "name": "Khenti the Bronze Warden",
      "description": "An ancient Egyptian priest-warrior adorned in bronze armor and mystical symbols.",
      "initialDialogue": [
        "I am Khenti, keeper of the bronze mysteries.",
        "You have learned to shape metal, but do you understand its true power?",
        "The gods demand a trial before you may ascend to greater knowledge!"
      ],
      "defeatDialogue": [
        "By Ra's light... you have proven yourself worthy.",
        "The bronze age has taught you well, young civilization.",
        "Take this wisdom forward - may your empires rise like the sun!"
      ],
      "playerDefeatDialogue": [
        "Your grasp of metal is crude, your ambition misplaced. The gods are not pleased.",
        "Return to your clay pits and contemplate your failure.",
        "You are not yet worthy of the secrets of bronze."
      ],
      "deck": ["clay", "pottery", "wheel", "wood", "tree", "art", "myth", "religion", "story", "sculpture", "ritual"]
    },
    "classical_age": {
      "name": "Marcus Philosophicus",
      "description": "A Roman general-philosopher in gleaming armor, representing the pinnacle of classical civilization.",
      "initialDialogue": [
        "Salve! I am Marcus, defender of the classical order.",
        "You have built great cities and learned the arts of war and peace.",
        "But can your civilization withstand the test of true leadership?"
      ],
      "defeatDialogue": [
        "Magnificus! Your wisdom rivals that of the greatest senators.",
        "You have proven that civilization can evolve beyond our achievements.",
        "Go forth and build upon the foundations we have laid!"
      ],
      "playerDefeatDialogue": [
        "Your strategy is flawed, your logic weak. A civilization built on such foundations cannot stand.",
        "Return to your studies. True strength comes from order and discipline, which you clearly lack."
      ],
      "deck": ["metal", "army", "nation", "ship", "sailing", "writing", "symbol", "trade", "market", "temple", "wind"]
    },
    "medieval_age": {
      "name": "Sir Aldric the Ironbound",
      "description": "A towering knight in full plate armor, champion of chivalry and feudal honor.",
      "initialDialogue": [
        "Hold, traveler! I am Sir Aldric, guardian of the old codes.",
        "You seek to move beyond the age of knights and castles?",
        "Then prove your honor in combat, as befits a true warrior!"
      ],
      "defeatDialogue": [
        "By my sword... you fight with honor and wisdom.",
        "The age of knights may pass, but chivalry lives in your heart.",
        "I grant you passage to the age of enlightenment!"
      ],
      "playerDefeatDialogue": [
        "You lack honor! Your tactics are clumsy and without merit.",
        "The code of chivalry is beyond your grasp.",
        "Return to your hovel and learn the meaning of true strength before you challenge me again."
      ],
      "deck": ["castle", "knight", "siege_tower", "catapult", "horse", "farm", "bridge", "church"]
    },
    "renaissance": {
      "name": "Leonardo da Machina",
      "description": "A brilliant inventor-artist with mechanical wings and Renaissance finery, master of art and science.",
      "initialDialogue": [
        "Ah, a fellow seeker of knowledge! I am Leonardo da Machina.",
        "You have rediscovered art, science, and human potential.",
        "But can you solve the greatest puzzle - the future itself?"
      ],
      "defeatDialogue": [
        "Incredibile! Your mind works like the finest clockwork.",
        "You have proven that human ingenuity knows no bounds.",
        "Fly forward on wings of innovation, my friend!"
      ],
      "playerDefeatDialogue": [
        "Your designs are uninspired, your execution lacking.",
        "You mimic the form of genius without understanding its substance.",
        "Go back to your workshop and pray for a spark of true inspiration."
      ],
      "deck": ["printing_press", "map", "globe", "gold", "bank", "arena", "sport", "game", "travel", "road"]
    },
    "industrial_age": {
      "name": "Baron Steamheart",
      "description": "A steam-powered industrialist with mechanical limbs and a top hat, master of the machine age.",
      "initialDialogue": [
        "Welcome to the age of steam and steel! I am Baron Steamheart.",
        "You've harnessed the power of machines, but at what cost?",
        "Show me you can master industry without losing your humanity!"
      ],
      "defeatDialogue": [
        "Remarkable! You've proven that progress need not mean perdition.",
        "The machines serve you, not the other way around.",
        "Steam ahead into the modern world, but remember this lesson!"
      ],
      "playerDefeatDialogue": [
        "Inefficient! Your progress is stalled, your engines sputtering.",
        "You cannot command the age of industry with such feeble attempts.",
        "More power is needed! More... production!"
      ],
      "deck": ["steam", "engine", "factory", "train", "tank", "electricity", "lightning", "storm", "wire", "trawler_ship", "travel_poster"]
    },
    "modern_age": {
      "name": "General Atomicus",
      "description": "A military leader in a radiation suit, representing the atomic age's promise and peril.",
      "initialDialogue": [
        "Greetings, citizen. I am General Atomicus of the Atomic Command.",
        "You've split the atom and reached for the stars.",
        "But can you handle the awesome responsibility of such power?"
      ],
      "defeatDialogue": [
        "Outstanding! You've shown that great power can be wielded wisely.",
        "The atomic age is yours to command, but use it for peace.",
        "The information age awaits - may you connect the world in harmony!"
      ],
      "playerDefeatDialogue": [
        "Your command of this power is reckless and insufficient. You are a danger to yourself and the world.",
        "Stand down and reconsider your approach before you cause a meltdown of your own making."
      ],
      "deck": ["airplane", "car", "rocket", "submarine", "telescope", "glass", "sand", "sky", "space", "tube"]
    },
    "information_age": {
      "name": "Cypher the Networked",
      "description": "A cybernetic being of pure information, guardian of the digital realm.",
      "initialDialogue": [
        "GREETINGS, USER. I AM CYPHER, GUARDIAN OF THE NETWORK.",
        "YOU HAVE CONNECTED THE WORLD THROUGH INFORMATION.",
        "BUT CAN YOU PROVE YOU DESERVE ACCESS TO THE FINAL FRONTIER?"
      ],
      "defeatDialogue": [
        "IMPRESSIVE. YOUR LOGIC CIRCUITS ARE HIGHLY OPTIMIZED.",
        "YOU HAVE SHOWN THAT HUMANITY AND TECHNOLOGY CAN COEXIST.",
        "INITIATING SPACE AGE PROTOCOLS... WELCOME TO THE COSMOS."
      ],
      "playerDefeatDialogue": [
        "LOGIC ERROR. YOUR ATTEMPT TO ASCEND IS INVALID.",
        "YOUR PROTOCOLS ARE INSUFFICIENT.",
        "RETURN TO THE PREVIOUS NODE AND RECOMPILE YOUR STRATEGY. ACCESS DENIED."
      ],
      "deck": ["computer", "internet", "chip", "silicon", "network", "node", "link", "smartphone", "telephone", "voice"]
    },
    "space_age": {
      "name": "Cosmos the Eternal",
      "description": "A transcendent being of starlight and cosmic energy, guardian of the universe itself.",
      "initialDialogue": [
        "Mortal civilization... you have traveled far from your humble origins.",
        "I am Cosmos, witness to the birth and death of stars.",
        "You seek to join the cosmic community? Prove your worthiness!"
      ],
      "defeatDialogue": [
        "Astounding... you have achieved true cosmic consciousness.",
        "Your species has earned its place among the stars.",
        "Go forth and explore the infinite - the universe is yours to discover!"
      ],
      "playerDefeatDialogue": [
        "Your consciousness is but a flicker in the vastness of time.",
        "You are not yet ready to comprehend the cosmic symphony.",
        "Return to your star system and grow. The universe can wait."
      ],
      "deck": ["star", "sun", "plasma", "robot", "ai_core", "space_station", "mars_colony", "terraformer", "solar_panel", "mech_god"]
    }
  },
  "player": {
    "name": "The Alchemist",
    "defaultAvatarKey": "alchemist",
    "avatars": [
      {
        "key": "alchemist",
        "name": "The Alchemist"
      },
      {
        "key": "flintknapper",
        "name": "The Flintknapper",
        "collectionRequirement": "first_tools"
      },
      {
        "key": "architect",
        "name": "The Architect",
        "collectionRequirement": "ancient_wonders"
      },
      {
        "key": "hacker",
        "name": "The Hacker",
        "collectionRequirement": "digital_revolution"
      },
      {
        "key": "bard",
        "name": "The Bard",
        "collectionRequirement": "art_and_culture"
      },
      {
        "key": "inventor",
        "name": "The Inventor",
        "collectionRequirement": "industrial_revolution"
      },
      {
        "key": "astronaut",
        "name": "The Astronaut",
        "collectionRequirement": "cosmic_pioneers"
      }
    ]
  },
  "cardGame": {
    "playerRoundsToWin": 2,
    "bossRoundsToWin": 2,
    "handSize": 10,
    "deckSize": 30,
    "fieldSlots": 6,
    "cardsPerRound": 3,
    "eraPowerMultiplier": 0.15,
    "futureTimeBonusPerEra": 2,
    "bossBattleDeckComposition": {
      "priorityEraRatio": 0.7,
      "otherErasRatio": 0.3
    },
    "categoryStats": {
      "materials": { "power": 2, "description": "Solid and reliable, but not very powerful." },
      "technology": { "power": 5, "description": "High-impact and game-changing." },
      "society": { "power": 3, "description": "Represents collective effort and strategy." },
      "nature": { "power": 3, "description": "Wild and unpredictable power." },
      "infrastructure": { "power": 4, "description": "Strong and foundational." },
      "knowledge": { "power": 1, "description": "Weak in direct power, but enables powerful combinations." }
    }
  },
  "deckBuilding": {
    "deckSizeMin": 20,
    "deckSizeMax": 30,
    "maxCardCopies": 3
  },
  "combinations": [
    {
      "a": "chip",
      "b": "robot",
      "result": "ai_core"
    },
    {
      "a": "computer",
      "b": "robot",
      "result": "ai_core"
    },
    {
      "a": "engine",
      "b": "air",
      "result": "airplane"
    },
    {
      "a": "engine",
      "b": "travel",
      "result": "airplane"
    },
    {
      "a": "hunting",
      "b": "water",
      "result": "animal"
    },
    {
      "a": "tribe",
      "b": "fishing",
      "result": "animal"
    },
    {
      "a": "army",
      "b": "sport",
      "result": "arena"
    },
    {
      "a": "festival",
      "b": "army",
      "result": "arena"
    },
    {
      "a": "nation",
      "b": "hunting",
      "result": "army"
    },
    {
      "a": "nation",
      "b": "tool",
      "result": "army"
    },
    {
      "a": "music",
      "b": "plant",
      "result": "art"
    },
    {
      "a": "tool",
      "b": "festival",
      "result": "art"
    },
    {
      "a": "market",
      "b": "nation",
      "result": "bank"
    },
    {
      "a": "gold",
      "b": "nation",
      "result": "bank"
    },
    {
      "a": "stone",
      "b": "wheel",
      "result": "bridge"
    },
    {
      "a": "tool",
      "b": "stone",
      "result": "bridge"
    },
    {
      "a": "stone",
      "b": "shelter",
      "result": "building"
    },
    {
      "a": "tool",
      "b": "shelter",
      "result": "building"
    },
    {
      "a": "engine",
      "b": "metal",
      "result": "car"
    },
    {
      "a": "factory",
      "b": "engine",
      "result": "car"
    },
    {
      "a": "stone",
      "b": "army",
      "result": "castle"
    },
    {
      "a": "nation",
      "b": "stone",
      "result": "castle"
    },
    {
      "a": "tool",
      "b": "castle",
      "result": "catapult"
    },
    {
      "a": "wood",
      "b": "army",
      "result": "catapult"
    },
    {
      "a": "metal",
      "b": "silicon",
      "result": "chip"
    },
    {
      "a": "factory",
      "b": "silicon",
      "result": "chip"
    },
    {
      "a": "religion",
      "b": "castle",
      "result": "church"
    },
    {
      "a": "temple",
      "b": "nation",
      "result": "church"
    },
    {
      "a": "earth",
      "b": "stone",
      "result": "clay"
    },
    {
      "a": "stone",
      "b": "plant",
      "result": "clay"
    },
    {
      "a": "tribe",
      "b": "animal",
      "result": "clothing"
    },
    {
      "a": "tribe",
      "b": "hunting",
      "result": "clothing"
    },
    {
      "a": "electricity",
      "b": "chip",
      "result": "computer"
    },
    {
      "a": "factory",
      "b": "chip",
      "result": "computer"
    },
    {
      "a": "animal",
      "b": "fire",
      "result": "cooking"
    },
    {
      "a": "fire",
      "b": "tribe",
      "result": "cooking"
    },
    {
      "a": "stone",
      "b": "stone",
      "result": "earth"
    },
    {
      "a": "stone",
      "b": "water",
      "result": "earth"
    },
    {
      "a": "engine",
      "b": "light",
      "result": "electricity"
    },
    {
      "a": "metal",
      "b": "light",
      "result": "electricity"
    },
    {
      "a": "factory",
      "b": "fire",
      "result": "engine"
    },
    {
      "a": "metal",
      "b": "fire",
      "result": "engine"
    },
    {
      "a": "plant",
      "b": "tool",
      "result": "farm"
    },
    {
      "a": "tribe",
      "b": "plant",
      "result": "farm"
    },
    {
      "a": "cooking",
      "b": "fishing",
      "result": "feast"
    },
    {
      "a": "cooking",
      "b": "hunting",
      "result": "feast"
    },
    {
      "a": "music",
      "b": "tribe",
      "result": "festival"
    },
    {
      "a": "tribe",
      "b": "feast",
      "result": "festival"
    },
    {
      "a": "tool",
      "b": "water",
      "result": "fishing"
    },
    {
      "a": "tribe",
      "b": "water",
      "result": "fishing"
    },
    {
      "a": "engine",
      "b": "building",
      "result": "factory"
    },
    {
      "a": "metal",
      "b": "building",
      "result": "factory"
    },
    {
      "a": "arena",
      "b": "tribe",
      "result": "game"
    },
    {
      "a": "sport",
      "b": "tool",
      "result": "game"
    },
    {
      "a": "sand",
      "b": "fire",
      "result": "glass"
    },
    {
      "a": "sand",
      "b": "light",
      "result": "glass"
    },
    {
      "a": "map",
      "b": "nation",
      "result": "globe"
    },
    {
      "a": "map",
      "b": "trade",
      "result": "globe"
    },
    {
      "a": "metal",
      "b": "earth",
      "result": "gold"
    },
    {
      "a": "sun",
      "b": "metal",
      "result": "gold"
    },
    {
      "a": "animal",
      "b": "farm",
      "result": "horse"
    },
    {
      "a": "tribe",
      "b": "shelter",
      "result": "horse"
    },
    {
      "a": "animal",
      "b": "stone",
      "result": "hunting"
    },
    {
      "a": "tool",
      "b": "tribe",
      "result": "hunting"
    },
    {
      "a": "computer",
      "b": "wire",
      "result": "internet"
    },
    {
      "a": "computer",
      "b": "network",
      "result": "internet"
    },
    {
      "a": "army",
      "b": "horse",
      "result": "knight"
    },
    {
      "a": "army",
      "b": "gold",
      "result": "knight"
    },
    {
      "a": "fire",
      "b": "air",
      "result": "light"
    },
    {
      "a": "glass",
      "b": "fire",
      "result": "light"
    },
    {
      "a": "sky",
      "b": "electricity",
      "result": "lightning"
    },
    {
      "a": "storm",
      "b": "air",
      "result": "lightning"
    },
    {
      "a": "wire",
      "b": "node",
      "result": "link"
    },
    {
      "a": "wire",
      "b": "smartphone",
      "result": "link"
    },
    {
      "a": "travel",
      "b": "writing",
      "result": "map"
    },
    {
      "a": "ship",
      "b": "travel",
      "result": "map"
    },
    {
      "a": "farm",
      "b": "trade",
      "result": "market"
    },
    {
      "a": "nation",
      "b": "trade",
      "result": "market"
    },
    {
      "a": "rocket",
      "b": "shelter",
      "result": "mars_colony"
    },
    {
      "a": "rocket",
      "b": "farm",
      "result": "mars_colony"
    },
    {
      "a": "robot",
      "b": "religion",
      "result": "mech_god"
    },
    {
      "a": "engine",
      "b": "myth",
      "result": "mech_god"
    },
    {
      "a": "sand",
      "b": "stone",
      "result": "metal"
    },
    {
      "a": "lightning",
      "b": "stone",
      "result": "metal"
    },
    {
      "a": "tool",
      "b": "sound",
      "result": "music"
    },
    {
      "a": "tribe",
      "b": "sound",
      "result": "music"
    },
    {
      "a": "art",
      "b": "religion",
      "result": "myth"
    },
    {
      "a": "story",
      "b": "religion",
      "result": "myth"
    },
    {
      "a": "myth",
      "b": "tribe",
      "result": "nation"
    },
    {
      "a": "religion",
      "b": "tribe",
      "result": "nation"
    },
    {
      "a": "node",
      "b": "travel_poster",
      "result": "network"
    },
    {
      "a": "wire",
      "b": "link",
      "result": "network"
    },
    {
      "a": "computer",
      "b": "computer",
      "result": "node"
    },
    {
      "a": "chip",
      "b": "computer",
      "result": "node"
    },
    {
      "a": "earth",
      "b": "light",
      "result": "plant"
    },
    {
      "a": "sand",
      "b": "water",
      "result": "plant"
    },
    {
      "a": "fire",
      "b": "electricity",
      "result": "plasma"
    },
    {
      "a": "light",
      "b": "electricity",
      "result": "plasma"
    },
    {
      "a": "clay",
      "b": "fire",
      "result": "pottery"
    },
    {
      "a": "tool",
      "b": "clay",
      "result": "pottery"
    },
    {
      "a": "building",
      "b": "writing",
      "result": "printing_press"
    },
    {
      "a": "writing",
      "b": "metal",
      "result": "printing_press"
    },
    {
      "a": "sculpture",
      "b": "tribe",
      "result": "religion"
    },
    {
      "a": "story",
      "b": "tribe",
      "result": "religion"
    },
    {
      "a": "fire",
      "b": "religion",
      "result": "ritual"
    },
    {
      "a": "religion",
      "b": "festival",
      "result": "ritual"
    },
    {
      "a": "earth",
      "b": "sand",
      "result": "road"
    },
    {
      "a": "stone",
      "b": "bridge",
      "result": "road"
    },
    {
      "a": "engine",
      "b": "steam",
      "result": "robot"
    },
    {
      "a": "factory",
      "b": "electricity",
      "result": "robot"
    },
    {
      "a": "engine",
      "b": "airplane",
      "result": "rocket"
    },
    {
      "a": "engine",
      "b": "space",
      "result": "rocket"
    },
    {
      "a": "air",
      "b": "ship",
      "result": "sailing"
    },
    {
      "a": "ship",
      "b": "wind",
      "result": "sailing"
    },
    {
      "a": "stone",
      "b": "air",
      "result": "sand"
    },
    {
      "a": "stone",
      "b": "wind",
      "result": "sand"
    },
    {
      "a": "art",
      "b": "stone",
      "result": "sculpture"
    },
    {
      "a": "tool",
      "b": "art",
      "result": "sculpture"
    },
    {
      "a": "stone",
      "b": "tribe",
      "result": "shelter"
    },
    {
      "a": "wood",
      "b": "tribe",
      "result": "shelter"
    },
    {
      "a": "wood",
      "b": "tool",
      "result": "ship"
    },
    {
      "a": "wood",
      "b": "wheel",
      "result": "ship"
    },
    {
      "a": "building",
      "b": "army",
      "result": "siege_tower"
    },
    {
      "a": "wood",
      "b": "castle",
      "result": "siege_tower"
    },
    {
      "a": "sand",
      "b": "electricity",
      "result": "silicon"
    },
    {
      "a": "factory",
      "b": "sand",
      "result": "silicon"
    },
    {
      "a": "air",
      "b": "light",
      "result": "sky"
    },
    {
      "a": "air",
      "b": "sun",
      "result": "sky"
    },
    {
      "a": "chip",
      "b": "telephone",
      "result": "smartphone"
    },
    {
      "a": "computer",
      "b": "telephone",
      "result": "smartphone"
    },
    {
      "a": "sun",
      "b": "chip",
      "result": "solar_panel"
    },
    {
      "a": "sun",
      "b": "electricity",
      "result": "solar_panel"
    },
    {
      "a": "air",
      "b": "tribe",
      "result": "sound"
    },
    {
      "a": "tool",
      "b": "air",
      "result": "sound"
    },
    {
      "a": "rocket",
      "b": "sky",
      "result": "space"
    },
    {
      "a": "telescope",
      "b": "sky",
      "result": "space"
    },
    {
      "a": "rocket",
      "b": "building",
      "result": "space_station"
    },
    {
      "a": "rocket",
      "b": "nation",
      "result": "space_station"
    },
    {
      "a": "game",
      "b": "tribe",
      "result": "sport"
    },
    {
      "a": "festival",
      "b": "music",
      "result": "sport"
    },
    {
      "a": "space",
      "b": "light",
      "result": "star"
    },
    {
      "a": "space",
      "b": "wind",
      "result": "star"
    },
    {
      "a": "engine",
      "b": "water",
      "result": "steam"
    },
    {
      "a": "fire",
      "b": "water",
      "result": "steam"
    },
    {
      "a": "air",
      "b": "lightning",
      "result": "storm"
    },
    {
      "a": "wind",
      "b": "water",
      "result": "storm"
    },
    {
      "a": "symbol",
      "b": "tribe",
      "result": "story"
    },
    {
      "a": "writing",
      "b": "tribe",
      "result": "story"
    },
    {
      "a": "engine",
      "b": "ship",
      "result": "submarine"
    },
    {
      "a": "ship",
      "b": "factory",
      "result": "submarine"
    },
    {
      "a": "star",
      "b": "fire",
      "result": "sun"
    },
    {
      "a": "star",
      "b": "light",
      "result": "sun"
    },
    {
      "a": "art",
      "b": "story",
      "result": "symbol"
    },
    {
      "a": "myth",
      "b": "story",
      "result": "symbol"
    },
    {
      "a": "engine",
      "b": "army",
      "result": "tank"
    },
    {
      "a": "engine",
      "b": "knight",
      "result": "tank"
    },
    {
      "a": "wire",
      "b": "sound",
      "result": "telephone"
    },
    {
      "a": "wire",
      "b": "voice",
      "result": "telephone"
    },
    {
      "a": "glass",
      "b": "metal",
      "result": "telescope"
    },
    {
      "a": "tube",
      "b": "glass",
      "result": "telescope"
    },
    {
      "a": "stone",
      "b": "religion",
      "result": "temple"
    },
    {
      "a": "tool",
      "b": "religion",
      "result": "temple"
    },
    {
      "a": "mars_colony",
      "b": "water",
      "result": "terraformer"
    },
    {
      "a": "mars_colony",
      "b": "plant",
      "result": "terraformer"
    },
    {
      "a": "earth",
      "b": "fire",
      "result": "tool"
    },
    {
      "a": "fire",
      "b": "stone",
      "result": "tool"
    },
    {
      "a": "bridge",
      "b": "nation",
      "result": "trade"
    },
    {
      "a": "nation",
      "b": "ship",
      "result": "trade"
    },
    {
      "a": "engine",
      "b": "nation",
      "result": "train"
    },
    {
      "a": "engine",
      "b": "road",
      "result": "train"
    },
    {
      "a": "trade",
      "b": "road",
      "result": "travel"
    },
    {
      "a": "ship",
      "b": "road",
      "result": "travel"
    },
    {
      "a": "art",
      "b": "travel",
      "result": "travel_poster"
    },
    {
      "a": "train",
      "b": "art",
      "result": "travel_poster"
    },
    {
      "a": "engine",
      "b": "fishing",
      "result": "trawler_ship"
    },
    {
      "a": "ship",
      "b": "electricity",
      "result": "trawler_ship"
    },
    {
      "a": "earth",
      "b": "plant",
      "result": "tree"
    },
    {
      "a": "water",
      "b": "plant",
      "result": "tree"
    },
    {
      "a": "wood",
      "b": "glass",
      "result": "tube"
    },
    {
      "a": "wheel",
      "b": "glass",
      "result": "tube"
    },
    {
      "a": "animal",
      "b": "sound",
      "result": "voice"
    },
    {
      "a": "animal",
      "b": "sky",
      "result": "voice"
    },
    {
      "a": "air",
      "b": "tree",
      "result": "wind"
    },
    {
      "a": "air",
      "b": "plant",
      "result": "wind"
    },
    {
      "a": "animal",
      "b": "tool",
      "result": "wheel"
    },
    {
      "a": "tree",
      "b": "wood",
      "result": "wheel"
    },
    {
      "a": "factory",
      "b": "glass",
      "result": "wire"
    },
    {
      "a": "metal",
      "b": "telescope",
      "result": "wire"
    },
    {
      "a": "fire",
      "b": "tree",
      "result": "wood"
    },
    {
      "a": "tool",
      "b": "tree",
      "result": "wood"
    },
    {
      "a": "clay",
      "b": "symbol",
      "result": "writing"
    },
    {
      "a": "story",
      "b": "symbol",
      "result": "writing"
    }
  ],
  "credits": {
    "music": [
      "kadumago",
      "Tatamusic",
      "Luis_Humanoide",
      "Mohamed_hassan",
      "Renrebello",
      "XaEnvironment",
      "Beau Buckley",
      "Tausdei",
      "Spring (Rasmus Damsgaard)"
    ]
  },
  "drag": {
    "dragStartDelay": 50,
    "highlightUpdateThrottle": 16,
    "repulsionDistance": 24,
    "smoothingFactor": 0.8,
    "threshold": 48
  },
  "elements": {
    "ai_core": {
      "category": "technology",
      "description": "A self-aware artificial intelligence, capable of unimaginable computational feats.",
      "era": "space_age",
      "name": "AI Core"
    },
    "air": {
      "category": "materials",
      "description": "Invisible and ever-present. Wind carries seeds, storms, and ideas.",
      "era": "primordial_age",
      "name": "Air"
    },
    "airplane": {
      "category": "technology",
      "description": "A powered, fixed-wing aircraft that is propelled forward by thrust from a jet engine, propeller, or rocket engine.",
      "era": "modern_age",
      "name": "Airplane"
    },
    "animal": {
      "category": "nature",
      "description": "Living creatures of the wild. Companions, resources, and fellow beings.",
      "era": "stone_age",
      "name": "Animal"
    },
    "arena": {
      "category": "infrastructure",
      "description": "A grand amphitheater where gladiators and athletes compete for glory and entertainment.",
      "era": "renaissance",
      "name": "Arena"
    },
    "army": {
      "category": "society",
      "description": "An organized military force equipped for fighting on land.",
      "era": "classical_age",
      "name": "Army"
    },
    "art": {
      "category": "knowledge",
      "description": "The expression of human creative skill and imagination.",
      "era": "bronze_age",
      "name": "Art"
    },
    "bank": {
      "category": "society",
      "description": "An institution that handles money, loans, and financial transactions.",
      "era": "renaissance",
      "name": "Bank"
    },
    "bridge": {
      "category": "infrastructure",
      "description": "A structure carrying a road, path, railway, etc. across a river, road, or other obstacle.",
      "era": "medieval_age",
      "name": "Bridge"
    },
    "building": {
      "category": "infrastructure",
      "description": "A permanent structure with walls and a roof, used for various purposes.",
      "era": "industrial_age",
      "name": "Building"
    },
    "car": {
      "category": "technology",
      "description": "A four-wheeled road vehicle that is powered by an engine and is able to carry a small number of people.",
      "era": "modern_age",
      "name": "Car"
    },
    "castle": {
      "category": "infrastructure",
      "description": "A large fortified building or group of buildings, often the residence of a noble or lord.",
      "era": "medieval_age",
      "name": "Castle"
    },
    "catapult": {
      "category": "technology",
      "description": "A military machine used in ancient and medieval warfare for hurling large stones or other missiles.",
      "era": "medieval_age",
      "name": "Catapult"
    },
    "chip": {
      "category": "technology",
      "description": "A small semiconductor device that processes information and powers modern electronics.",
      "era": "information_age",
      "name": "Chip"
    },
    "church": {
      "category": "infrastructure",
      "description": "A building used for public Christian worship.",
      "era": "medieval_age",
      "name": "Church"
    },
    "clay": {
      "category": "materials",
      "description": "Moist earth, moldable and soft. Can be hardened by fire.",
      "era": "bronze_age",
      "name": "Clay"
    },
    "clothing": {
      "category": "society",
      "description": "Protection and identity. Warmth, modesty, and personal expression.",
      "era": "stone_age",
      "name": "Clothing"
    },
    "computer": {
      "category": "technology",
      "description": "An electronic device that processes data and performs calculations at incredible speeds.",
      "era": "information_age",
      "name": "Computer"
    },
    "cooking": {
      "category": "society",
      "description": "Fire transforms food. Nutrition, flavor, and community meals.",
      "era": "stone_age",
      "name": "Cooking"
    },
    "earth": {
      "category": "materials",
      "description": "The solid ground beneath our feet, a foundation for all that will grow.",
      "era": "primordial_age",
      "name": "Earth"
    },
    "electricity": {
      "category": "materials",
      "description": "The power that drives modern machines and illuminates the darkness.",
      "era": "industrial_age",
      "name": "Electricity"
    },
    "engine": {
      "category": "technology",
      "description": "A machine that converts thermal energy into mechanical motion.",
      "era": "industrial_age",
      "name": "Engine"
    },
    "factory": {
      "category": "infrastructure",
      "description": "A large building where goods are manufactured in mass quantities by machines.",
      "era": "industrial_age",
      "name": "Factory"
    },
    "farm": {
      "category": "infrastructure",
      "description": "An area of land and its buildings used for growing crops and rearing animals.",
      "era": "medieval_age",
      "name": "Farm"
    },
    "feast": {
      "category": "society",
      "description": "Abundance shared together. Celebration through food and gathering.",
      "era": "stone_age",
      "name": "Feast"
    },
    "festival": {
      "category": "society",
      "description": "Joyous community celebration. Music, dance, and shared traditions.",
      "era": "stone_age",
      "name": "Festival"
    },
    "fire": {
      "category": "materials",
      "description": "Heat, light, and transformation. The spark of early technology.",
      "era": "primordial_age",
      "name": "Fire"
    },
    "fishing": {
      "category": "society",
      "description": "Harvesting from waters. Nets, hooks, and aquatic bounty.",
      "era": "stone_age",
      "name": "Fishing"
    },
    "game": {
      "category": "society",
      "description": "Structured play and competition that brings joy and builds community.",
      "era": "renaissance",
      "name": "Game"
    },
    "glass": {
      "category": "materials",
      "description": "A transparent or translucent material made by fusing sand with soda, lime, and sometimes other ingredients.",
      "era": "modern_age",
      "name": "Glass"
    },
    "globe": {
      "category": "knowledge",
      "description": "A spherical model of Earth, showing the world's geography and nations.",
      "era": "renaissance",
      "name": "Globe"
    },
    "gold": {
      "category": "materials",
      "description": "A precious metal that serves as currency and symbol of wealth.",
      "era": "renaissance",
      "name": "Gold"
    },
    "horse": {
      "category": "nature",
      "description": "A domesticated hoofed mammal, used for riding, racing, and to carry and pull loads.",
      "era": "medieval_age",
      "name": "Horse"
    },
    "hunting": {
      "category": "society",
      "description": "The pursuit of prey. Skill, patience, and survival combined.",
      "era": "stone_age",
      "name": "Hunting"
    },
    "internet": {
      "category": "technology",
      "description": "A global network of interconnected computers that revolutionizes communication and information sharing.",
      "era": "information_age",
      "name": "Internet"
    },
    "knight": {
      "category": "society",
      "description": "A man who served his sovereign or lord as a mounted soldier in armor.",
      "era": "medieval_age",
      "name": "Knight"
    },
    "light": {
      "category": "materials",
      "description": "Illumination that banishes darkness, revealing the world.",
      "era": "primordial_age",
      "name": "Light"
    },
    "lightning": {
      "category": "nature",
      "description": "A powerful and sudden discharge of atmospheric electricity.",
      "era": "industrial_age",
      "name": "Lightning"
    },
    "link": {
      "category": "technology",
      "description": "A connection that enables data to flow between different points in a network.",
      "era": "information_age",
      "name": "Link"
    },
    "map": {
      "category": "knowledge",
      "description": "A visual representation of an area showing geographical features and routes.",
      "era": "renaissance",
      "name": "Map"
    },
    "market": {
      "category": "society",
      "description": "A regular gathering of people for the purchase and sale of provisions, livestock, and other commodities.",
      "era": "classical_age",
      "name": "Market"
    },
    "mars_colony": {
      "category": "infrastructure",
      "description": "The first permanent human settlement on the Red Planet, a testament to perseverance.",
      "era": "space_age",
      "name": "Mars Colony"
    },
    "mech_god": {
      "category": "society",
      "description": "A colossal machine worshipped as a deity, blurring the line between technology and the divine.",
      "era": "space_age",
      "name": "Mech-God"
    },
    "metal": {
      "category": "materials",
      "description": "A solid material that is typically hard, shiny, malleable, fusible, and ductile, with good electrical and thermal conductivity.",
      "era": "classical_age",
      "name": "Metal"
    },
    "music": {
      "category": "knowledge",
      "description": "Rhythm and melody. Expression that moves the soul and unites people.",
      "era": "stone_age",
      "name": "Music"
    },
    "myth": {
      "category": "knowledge",
      "description": "A traditional story explaining natural or social phenomena, often involving supernatural beings.",
      "era": "bronze_age",
      "name": "Myth"
    },
    "nation": {
      "category": "society",
      "description": "A large body of people united by common descent, history, culture, or language, inhabiting a particular country or territory.",
      "era": "classical_age",
      "name": "Nation"
    },
    "network": {
      "category": "technology",
      "description": "An interconnected system of computers or devices that can communicate and share resources.",
      "era": "information_age",
      "name": "Network"
    },
    "node": {
      "category": "technology",
      "description": "A connection point in a network where data can be transmitted, received, or forwarded.",
      "era": "information_age",
      "name": "Node"
    },
    "plant": {
      "category": "nature",
      "description": "A living organism of the kind exemplified by trees, shrubs, herbs, grasses, and mosses.",
      "era": "stone_age",
      "name": "Plant"
    },
    "plasma": {
      "category": "materials",
      "description": "A superheated state of matter, the stuff of stars and fusion reactors.",
      "era": "space_age",
      "name": "Plasma"
    },
    "pottery": {
      "category": "technology",
      "description": "Hardened clay vessels. Used for storing food and water.",
      "era": "bronze_age",
      "name": "Pottery"
    },
    "printing_press": {
      "category": "technology",
      "description": "A mechanical device for reproducing text and images, revolutionizing the spread of knowledge.",
      "era": "renaissance",
      "name": "Printing Press"
    },
    "religion": {
      "category": "society",
      "description": "A system of faith and worship, providing moral guidance and a sense of purpose.",
      "era": "bronze_age",
      "name": "Religion"
    },
    "ritual": {
      "category": "society",
      "description": "A series of actions performed according to a prescribed order, often in a religious ceremony.",
      "era": "bronze_age",
      "name": "Ritual"
    },
    "road": {
      "category": "infrastructure",
      "description": "A paved way connecting places, enabling travel and trade.",
      "era": "renaissance",
      "name": "Road"
    },
    "robot": {
      "category": "technology",
      "description": "An autonomous machine built to serve, work, and sometimes, think.",
      "era": "space_age",
      "name": "Robot"
    },
    "rocket": {
      "category": "technology",
      "description": "A spacecraft that obtains thrust from a rocket engine.",
      "era": "modern_age",
      "name": "Rocket"
    },
    "sailing": {
      "category": "technology",
      "description": "The action of sailing a boat or ship.",
      "era": "classical_age",
      "name": "Sailing"
    },
    "sand": {
      "category": "materials",
      "description": "A loose granular substance, typically pale yellowish brown, resulting from the erosion of siliceous and other rocks.",
      "era": "modern_age",
      "name": "Sand"
    },
    "sculpture": {
      "category": "knowledge",
      "description": "Three-dimensional art, carved from stone or molded from clay.",
      "era": "bronze_age",
      "name": "Sculpture"
    },
    "shelter": {
      "category": "infrastructure",
      "description": "Protection from the elements. Safety, warmth, and belonging.",
      "era": "stone_age",
      "name": "Shelter"
    },
    "ship": {
      "category": "technology",
      "description": "A large boat for transporting people or goods by sea or other large bodies of water.",
      "era": "classical_age",
      "name": "Ship"
    },
    "siege_tower": {
      "category": "technology",
      "description": "A specialized siege engine, constructed to protect assailants and ladders while approaching the defensive walls of a fortification.",
      "era": "medieval_age",
      "name": "Siege Tower"
    },
    "silicon": {
      "category": "materials",
      "description": "A chemical element that forms the basis of computer chips and modern electronics.",
      "era": "information_age",
      "name": "Silicon"
    },
    "sky": {
      "category": "nature",
      "description": "The region of the atmosphere and outer space seen from the earth.",
      "era": "modern_age",
      "name": "Sky"
    },
    "smartphone": {
      "category": "technology",
      "description": "A mobile device that combines computing power with communication capabilities in your pocket.",
      "era": "information_age",
      "name": "Smartphone"
    },
    "solar_panel": {
      "category": "technology",
      "description": "A device that converts sunlight directly into electricity, powering the future.",
      "era": "space_age",
      "name": "Solar Panel"
    },
    "sound": {
      "category": "materials",
      "description": "Vibrations carried through the air, the first whispers of communication.",
      "era": "primordial_age",
      "name": "Sound"
    },
    "space": {
      "category": "nature",
      "description": "The boundless three-dimensional extent in which objects and events have relative position and direction.",
      "era": "modern_age",
      "name": "Space"
    },
    "space_station": {
      "category": "infrastructure",
      "description": "An orbital outpost for science, commerce, and a stepping stone to the cosmos.",
      "era": "space_age",
      "name": "Space Station"
    },
    "sport": {
      "category": "society",
      "description": "Physical activities and games that test skill, strength, and strategy.",
      "era": "renaissance",
      "name": "Sport"
    },
    "star": {
      "category": "nature",
      "description": "A luminous sphere of plasma held together by its own gravity, a distant sun in the night sky.",
      "era": "space_age",
      "name": "Star"
    },
    "steam": {
      "category": "materials",
      "description": "Water in its gaseous phase, a source of power.",
      "era": "industrial_age",
      "name": "Steam"
    },
    "stone": {
      "category": "materials",
      "description": "Hard, durable, and abundant. The basis for the first tools.",
      "era": "primordial_age",
      "name": "Stone"
    },
    "storm": {
      "category": "nature",
      "description": "A disturbance of the atmosphere marked by wind and usually rain, snow, or other precipitation.",
      "era": "industrial_age",
      "name": "Storm"
    },
    "story": {
      "category": "knowledge",
      "description": "A narrative of events. Shared to entertain, educate, or preserve culture.",
      "era": "bronze_age",
      "name": "Story"
    },
    "submarine": {
      "category": "technology",
      "description": "A watercraft capable of independent operation underwater.",
      "era": "modern_age",
      "name": "Submarine"
    },
    "sun": {
      "category": "nature",
      "description": "The star at the center of the solar system, the ultimate source of energy and life.",
      "era": "space_age",
      "name": "Sun"
    },
    "symbol": {
      "category": "knowledge",
      "description": "A thing that represents or stands for something else, especially a material object representing something abstract.",
      "era": "classical_age",
      "name": "Symbol"
    },
    "tank": {
      "category": "technology",
      "description": "A heavily armored fighting vehicle carrying guns and moving on a continuous articulated metal track.",
      "era": "industrial_age",
      "name": "Tank"
    },
    "telephone": {
      "category": "technology",
      "description": "A device that transmits voice over long distances using electrical signals.",
      "era": "information_age",
      "name": "Telephone"
    },
    "telescope": {
      "category": "technology",
      "description": "An optical instrument designed to make distant objects appear nearer.",
      "era": "modern_age",
      "name": "Telescope"
    },
    "temple": {
      "category": "infrastructure",
      "description": "A building devoted to the worship of a god or gods.",
      "era": "classical_age",
      "name": "Temple"
    },
    "terraformer": {
      "category": "technology",
      "description": "A massive engine designed to transform a planet's environment to be habitable for humans.",
      "era": "space_age",
      "name": "Terraformer"
    },
    "tool": {
      "category": "technology",
      "description": "A shaped aid for hands. Extends strength, precision, and purpose.",
      "era": "stone_age",
      "name": "Tool"
    },
    "trade": {
      "category": "society",
      "description": "The action of buying and selling goods and services.",
      "era": "classical_age",
      "name": "Trade"
    },
    "train": {
      "category": "technology",
      "description": "A series of connected railway carriages or wagons moved by a locomotive.",
      "era": "industrial_age",
      "name": "Train"
    },
    "travel": {
      "category": "society",
      "description": "The act of going from one place to another, often over long distances.",
      "era": "renaissance",
      "name": "Travel"
    },
    "travel_poster": {
      "category": "knowledge",
      "description": "Artistic advertisements that entice people to visit new and exciting destinations by train.",
      "era": "industrial_age",
      "name": "Travel Poster"
    },
    "trawler_ship": {
      "category": "technology",
      "description": "A fishing boat that uses a trawl net to catch fish on an industrial scale.",
      "era": "industrial_age",
      "name": "Trawler Ship"
    },
    "tree": {
      "category": "nature",
      "description": "A tall plant with a trunk and branches made of wood. A source of life and material.",
      "era": "bronze_age",
      "name": "Tree"
    },
    "tribe": {
      "category": "society",
      "description": "Community and cooperation. People working and living together.",
      "era": "primordial_age",
      "name": "Tribe"
    },
    "tube": {
      "category": "materials",
      "description": "A long, hollow cylinder of metal, plastic, glass, etc., for holding or transporting something.",
      "era": "modern_age",
      "name": "Tube"
    },
    "voice": {
      "category": "knowledge",
      "description": "The sound produced by humans for communication and expression.",
      "era": "information_age",
      "name": "Voice"
    },
    "water": {
      "category": "materials",
      "description": "Source of life and change. It shapes land and quenches thirst.",
      "era": "primordial_age",
      "name": "Water"
    },
    "wheel": {
      "category": "technology",
      "description": "A circular object that revolves on an axle, enabling movement.",
      "era": "bronze_age",
      "name": "Wheel"
    },
    "wind": {
      "category": "nature",
      "description": "The perceptible natural movement of the air.",
      "era": "classical_age",
      "name": "Wind"
    },
    "wire": {
      "category": "materials",
      "description": "A thin, flexible thread of metal.",
      "era": "industrial_age",
      "name": "Wire"
    },
    "wood": {
      "category": "materials",
      "description": "Harvested from trees. A versatile material for building and fuel.",
      "era": "bronze_age",
      "name": "Wood"
    },
    "writing": {
      "category": "knowledge",
      "description": "The art of recording language. A revolution in communication and knowledge.",
      "era": "classical_age",
      "name": "Writing"
    }
  },
  "eras": {
    "unlockThreshold": 0.5,
    "list": [
      {
        "color": "#334155",
        "description": "The chaotic beginnings before structured time. Fundamental forces and materials emerge.",
        "key": "primordial_age",
        "name": "Primordial Age"
      },
      {
        "color": "#a3a3a3",
        "description": "The dawn of human innovation. Tribes master fire, shape stone into tools, and begin to settle in simple shelters.",
        "key": "stone_age",
        "name": "Stone Age"
      },
      {
        "color": "#e97451",
        "description": "Humanity learns to work with metals, leading to more advanced tools, art, and societal structures.",
        "key": "bronze_age",
        "name": "Bronze Age"
      },
      {
        "color": "#8b5cf6",
        "description": "Empires rise and fall. Philosophy, democracy, and grand architecture shape the world.",
        "key": "classical_age",
        "name": "Classical Age"
      },
      {
        "color": "#7f1d1d",
        "description": "A time of castles, knights, and feudal kingdoms. Faith and warfare shape the land.",
        "key": "medieval_age",
        "name": "Medieval Age"
      },
      {
        "color": "#059669",
        "description": "A rebirth of art, science, and learning. Humanism flourishes as new technologies spread knowledge.",
        "key": "renaissance",
        "name": "Renaissance"
      },
      {
        "color": "#64748b",
        "description": "Steam and steel reshape the world. Factories rise, and new machines conquer land and sea.",
        "key": "industrial_age",
        "name": "Industrial Age"
      },
      {
        "color": "#4f46e5",
        "description": "The age of flight, automobiles, and the dawn of space exploration. Technology accelerates at an unprecedented pace.",
        "key": "modern_age",
        "name": "Modern Age"
      },
      {
        "color": "#10b981",
        "description": "The digital revolution transforms society. Computers, networks, and instant global communication reshape human interaction.",
        "key": "information_age",
        "name": "Information Age"
      },
      {
        "color": "#22d3ee",
        "description": "Humanity reaches for the stars, building colonies on other worlds and harnessing cosmic power. The final frontier awaits.",
        "key": "space_age",
        "name": "Space Age"
      }
    ]
  },
  "gameName": "Time Alchemist",
  "gameTitle": "Time Alchemist",
  "hints": {
    "unlockThreshold": 5
  },
  "music": {
    "crossfadeMs": 600,
    "defaultVolume": 0.35
  },
  "sfx": {
    "defaultVolume": 0.5
  },
  "startingElements": [
    "fire",
    "stone",
    "tribe",
    "water",
    "air"
  ],
  "tutorials": {
    "first_combination": {
      "steps": [
        { "target": "library_stone", "title": "First Combination", "text": "Welcome! To begin, drag a 'Stone' from your library on the right onto the main board." },
        { "target": "library_stone", "title": "First Combination", "text": "Great! Now drag another 'Stone' onto the board." },
        { "target": "board_stone", "title": "First Combination", "text": "Excellent. Drag one Stone on top of the other to combine them." },
        { "target": "none", "title": "Discovery!", "text": "You've made Earth! Combining elements is the key to progress. Keep experimenting to discover everything!" }
      ]
    },
    "first_boss_battle": {
      "steps": [
        { "target": "player_hand", "title": "Boss Battle!", "text": "This is a Boss Battle! Drag cards from your hand to one of the empty slots on your side of the field." },
        { "target": "field_slots", "title": "Card Power", "text": "Each card has a Power value. The side with the highest total Power at the end of the round wins a point." },
        { "target": "combine_on_field", "title": "Combine & Conquer", "text": "You can also drag a card from your hand onto a card already on the field to combine them into something new and more powerful!" },
        { "target": "pass_button", "title": "Passing Your Turn", "text": "If you don't want to play a card, you can Pass your turn. Once both players pass or the field is full, the round ends. Good luck!" }
      ]
    },
    "deck_builder_tutorial": {
      "steps": [
        { "target": "deck_builder_button", "title": "Deck Builder Unlocked!", "text": "You've unlocked the Deck Builder! You can access it any time from this button on the board." },
        { "target": "deck_builder_available_cards", "title": "Your Collection", "text": "This area shows all the elements you have discovered. You can click on them to add them to your deck." },
        { "target": "deck_builder_current_deck", "title": "Your Deck", "text": "This is your current deck. You can see the cards you've added and their quantities. Click on a card here to remove it from the deck." },
        { "target": "deck_builder_deck_stats", "title": "Deck Rules", "text": "Your deck must have between 20 and 30 cards. You can have up to 3 copies of any single card. When your deck is valid, you can save it." },
        { "target": "none", "title": "Ready for Battle!", "text": "That's it! Build a powerful deck to conquer the challenges of the next era. Good luck!" }
      ]
    }
  },
  "ui": {
    "library": {
      "categories": [
        {
          "color": "#8b5a2b",
          "description": "Basic substances and raw materials",
          "key": "materials",
          "name": "Materials",
          "frameAsset": "materials"
        },
        {
          "color": "#4f46e5",
          "description": "Tools, machines, and technological innovations",
          "key": "technology",
          "name": "Technology",
          "frameAsset": "technology"
        },
        {
          "color": "#059669",
          "description": "Social structures, institutions, and cultural elements",
          "key": "society",
          "name": "Society",
          "frameAsset": "society"
        },
        {
          "color": "#16a34a",
          "description": "Living things and natural phenomena",
          "key": "nature",
          "name": "Nature",
          "frameAsset": "nature"
        },
        {
          "color": "#64748b",
          "description": "Buildings, transportation, and large-scale constructions",
          "key": "infrastructure",
          "name": "Infrastructure",
          "frameAsset": "infrastructure"
        },
        {
          "color": "#7c3aed",
          "description": "Information, communication, and intellectual pursuits",
          "key": "knowledge",
          "name": "Knowledge",
          "frameAsset": "knowledge"
        }
      ],
      "eraHeader": {
        "angleDeg": 135,
        "borderRadius": 10,
        "height": 68
      },
      "eraStyles": {
        "bronze_age": {
          "gradientFrom": "#8c4a2f",
          "gradientTo": "#e69d6f"
        },
        "classical_age": {
          "gradientFrom": "#3b2a7b",
          "gradientTo": "#8b5cf6"
        },
        "industrial_age": {
          "gradientFrom": "#374151",
          "gradientTo": "#94a3b8"
        },
        "information_age": {
          "gradientFrom": "#0ea5e9",
          "gradientTo": "#22d3ee"
        },
        "medieval_age": {
          "gradientFrom": "#3a2a1a",
          "gradientTo": "#7f4f24"
        },
        "modern_age": {
          "gradientFrom": "#1e3a8a",
          "gradientTo": "#60a5fa"
        },
        "primordial_age": {
          "gradientFrom": "#0b132b",
          "gradientTo": "#1c2541"
        },
        "renaissance": {
          "gradientFrom": "#14532d",
          "gradientTo": "#22c55e"
        },
        "space_age": {
          "gradientFrom": "#0b132b",
          "gradientTo": "#22d3ee"
        },
        "stone_age": {
          "gradientFrom": "#7a6f63",
          "gradientTo": "#b8a99a"
        }
      },
      "sortMethods": [
        {
          "description": "Group elements by historical time periods",
          "key": "era",
          "name": "By Era"
        },
        {
          "description": "Group elements by their type and function",
          "key": "category",
          "name": "By Category"
        },
        {
          "description": "Sort elements alphabetically by name",
          "key": "name",
          "name": "Alphabetical"
        }
      ]
    },
    "theme": {
      "colors": {
        "accent": "#cd853f",
        "background": "#1a1611",
        "border": "#8b4513",
        "error": "#dc143c",
        "primary": "#daa520",
        "secondary": "#8b4513",
        "success": "#228b22",
        "surface": "#2d2419",
        "text": "#f4e4bc",
        "textSecondary": "#d4c19c",
        "warning": "#ff8c00"
      },
      "effects": {
        "ornateBoxShadow": "0 4px 8px rgba(0, 0, 0, 0.3), 0 8px 16px rgba(139, 69, 19, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
        "textGlow": "0 0 10px rgba(218, 165, 32, 0.5), 0 0 20px rgba(218, 165, 32, 0.3), 0 0 30px rgba(218, 165, 32, 0.2)"
      },
      "fonts": {
        "body": "Crimson Text",
        "title": "Cinzel"
      }
    }
  }
}
